import { LifeBuoy } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { SupportPage } from './pages/SupportPage'
import { SupportTicketPage } from './pages/SupportTicketPage'

/**
 * Customer Support Command & Control Center (2026-05-30).
 *
 * A Kanban project board for SPI's support team triaging inbound email at
 * support@siliconesplus.com. CARLA creates tickets, enriches them with Odoo
 * context, and drafts responses; the team reviews + sends. Shares the board
 * implementation via @/shell/services/support. Replaces the legacy MailDesk
 * inbox-actions routing for the Support inbox.
 */
export default defineModule({
  id: 'support',
  name: 'Customer Support',
  shortName: 'Support',
  icon: LifeBuoy,
  navSection: 'customer_service',
  navOrder: 10,
  urlNamespace: '/support',
  routes: [
    { path: '/', element: SupportPage, label: 'Customer Support' },
    // Per-ticket full-page working view. Registered AFTER `/`.
    { path: '/$ticketId', element: SupportTicketPage, label: 'Support ticket' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing', 'sales', 'regulatory', 'finance'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g u',

  commandPaletteEntries: [
    {
      label: 'Go to Customer Support',
      keywords: ['support', 'tickets', 'helpdesk', 'customer', 'sla', 'cs'],
      path: '/',
      group: 'modules',
      shortcut: 'g u',
    },
  ],
})
